__webpack_require__.p = "/assets/shell/content-only/scripts/";